import React, { useContext, useState } from 'react';
import { Event, EventSalesStats, locallyUpdateEventTicketsStats } from '../../../../../model/event';
import { Card } from '../../../../../components/Card/Card';
import { t } from '../../../../../locales/translate';
import { Stack } from '../../../../../components/Stack/Stack';
import { Button } from '../../../../../components/Button/Button';
import { Modal } from '../../../../../components/Modal/Modal';
import { FormForm } from '../../../../../components/Form/FormForm';
import { useAsyncIndicator } from '../../../../../util/util';
import { runTicketCodeUsageImport } from '../../../../../model/imports';
import { FormFileUpload } from '../../../../../components/Form/FileUpload/FormFileUpload';
import { ActivitiesContext } from '../../../../../components/Activities/Activities';

export function CodeUsageUpload({ event }: { event: Event }): JSX.Element {
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState<File | null | undefined>(null);
  const [loading, run] = useAsyncIndicator({ handleError: true });
  const { reloadActivities } = useContext(ActivitiesContext);

  return (
    <>
      <Card title={t.model.event.ticketCodeUsageUpload}>
        <Stack>
          <p>{t.model.event.ticketCodeUsageUploadDescription}</p>
          <Button title="upload" onClick={() => setShowModal(true)} />
        </Stack>
      </Card>
      <Modal title={t.model.event.ticketCodeUsageUpload} open={showModal}>
        {() => (
          <FormForm
            canSubmit={!!file}
            loading={loading}
            onClose={() => setShowModal(false)}
            onSubmit={async () => {
              const modifications = await run(runTicketCodeUsageImport(event.id, file!));
              locallyUpdateEventTicketsStats(event, modifications as Partial<EventSalesStats>);
              reloadActivities();
              setFile(null);
              setShowModal(false);
            }}
          >
            <FormFileUpload required accept="text/csv" value={file} onChange={(file) => setFile(file)} />
          </FormForm>
        )}
      </Modal>
    </>
  );
}
